import React from 'react';
import css from './CalendarSelectAppt.module.scss';
import { IconRemove } from 'src/content/icons';
import ScrollBar from 'src/components/ScrollBar/ScrollBar';

interface IProps {
    title: string;
    information: string;
    onClose: (e: any) => void;
    theme?: string;
}

const CalendarSelectApptInfo = (props: IProps) => {
    // Split 'infomration' on the new line to reflect char returns in specs
    const informationList = props.information.split('\n');
    const informationDivs = informationList.map((info, index) => <div key={index} className={css.infoDivs}>{info}</div>);

    return (
        <div>
            <IconRemove id={'closeBtn'} onClick={props.onClose} className={css.removeIcon} />
            <ScrollBar scrollHorizontal theme={props.theme}>
                <h2>{props.title}</h2>
                <div key={props.title + '0'}>
                    {informationDivs}
                </div>
            </ScrollBar>
        </div>
    );
};

export default CalendarSelectApptInfo;